<template>
  <div style="overflow: hidden; position: relative">
    <vs-row class="modal-wrapper">
      <vs-col
        class="mb-4"
        vs-justify="center"
        vs-align="center"
        :vs-w="createMode ? 12 : 6"
      >
        نام دسته بندی
        <vs-input
          placeholder="نام دسته بندی"
          v-model="categoryClone.title"
          class="w-100 mt-1"
        />
      </vs-col>
      <template v-if="!createMode">
        <vs-col class="mb-4" vs-justify="center" vs-align="center" vs-w="6">
          ترتیب نمایش
          <vs-input
            placeholder="ترتیب نمایش"
            v-model="categoryClone.level"
            class="w-100 mt-1"
          />
        </vs-col>
      </template>
      <vs-col class="mb-4" vs-w="12">
        <attachments
          ref="thumbnailAttachments"
          :data="categoryClone.thumbnail ? [categoryClone.thumbnail] : []"
          :aspectRatio="2"
          :multiple="false"
          accept="image/*"
          :urlForDelete="`categories/${categoryClone.id}/`"
          title="انتخاب تصویر:"
          hiddenTitle
        />
      </vs-col>
      <div class="flex justify-between mb-2 px-4 w-full items-center gap-4">
        <div class="flex-1">
          <vs-checkbox
            v-model="categoryClone.visible"
            :value="categoryClone.visible"
            >نمایش دسته بندی</vs-checkbox
          >
        </div>
        <div class="flex-1">
          <vs-checkbox
            v-model="categoryClone.available"
            :value="categoryClone.available"
            >موجودیت محصولات این دسته بندی</vs-checkbox
          >
        </div>
      </div>
    </vs-row>
    <div class="footer">
      <div class="footer-actions">
        <loading-button
          containerClassName="w-full p-0 flex-grow max-w-full flex-1  flex-shrink-0"
          className="w-full max-w-full"
          :title="(createMode ? 'ایجاد' : 'ویرایش') + ' دسته بندی'"
          :loading="loading"
          :progress="progress"
          @confirm="sendRequest"
          @cancelUpload="cancelUpload"
        />
        <vs-button
          v-if="!createMode"
          @click="remove()"
          class="remove-btn w-full flex-1 px-0"
          color="danger"
          type="border"
          size="small"
        >
          <img
            style="width: 14px; margin-bottom: -4px; margin-left: 4px"
            src="../../assets/icons/trash.svg"
          />
          حذف دسته بندی
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import Attachments from "../../views/tickets/form/Attachments.vue";
  import LoadingButton from "../loading-button/LoadingButton.vue";
  import productApiService from "./../../services/api/ProductApiService";

  export default {
    name: "Input",
    components: { Attachments, LoadingButton },
    data() {
      return {
        categoryClone: { ...this.value },
        category: this.value,
        Blob: window.Blob,
        progress: 0,
        loading: false,
        abortController: null,
      };
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    mounted() {
      if (this.createMode)
        this.categoryClone = {
          ...this.value,
          available: true,
        };
    },
    methods: {
      handleUpload(blob) {
        this.categoryClone = {
          ...this.categoryClone,
          thumbnail: {
            url: blob,
          },
        };
      },
      checkLevel() {
        return this.categories
          ? this.categories[this.categories.length - 1]
            ? +this.categories[this.categories.length - 1].level + 1
            : 1
          : 1;
      },
      sendRequest() {
        this.abortController = new AbortController();

        this.categoryClone = {
          ...this.categoryClone,
          thumbnail: this.$refs.thumbnailAttachments.getData(),
        };

        const category = { ...this.categoryClone };

        if (this.createMode) category.level = this.checkLevel();

        if (!category.title) {
          this.$vs.notify({
            text: "لطفا تمامی فیلد ها را وارد کنید",
            color: "danger",
            position: "bottom-center",
          });
          return;
        }

        this.loading = true;
        productApiService
          .createOrEditCategory(
            this.currentProvider.id,
            category.id,
            category,
            null,
            this.updateProgress,
            this.abortController
          )
          .then((result) => {
            this.$emit("close");
            this.$emit(
              this.createMode ? "categoryAdded" : "categoryUpdated",
              result.resource
            );
            this.$vs.notify({
              text: "عملیات با موفقیت انجام شد.",
              color: "success",
              position: "bottom-center",
            });
          })
          .catch((err) => {
            if (err.status == 0) return;

            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.progress = 0;
            this.loading = false;
          });
      },
      updateProgress(percent) {
        this.progress = +percent;
      },
      cancelUpload() {
        this.progress = 0;
        this.abortController.abort();
      },
      remove() {
        this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "حذف دسته بندی",
          text: `از حذف دسته بندی "${this.categoryClone.title}" اطمینان دارید؟`,
          acceptText: "بلی",
          cancelText: "خیر",
          accept: () => {
            this.$emit("delete");
          },
        });
      },
    },
    watch: {
      category(selectedCategory) {
        if (!this.createMode) {
          this.categoryClone = { ...selectedCategory };
        }
      },
    },
    props: {
      value: {
        type: Object,
      },
      categories: {
        type: Array,
        required: true,
      },
      createMode: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped lang="scss">
  .modal-wrapper {
    position: relative;
    padding-bottom: 28px;
    max-height: 700px;
    overflow-y: scroll;
  }
  .footer {
    z-index: 100;
    background-color: #fff;
    padding: 1rem 0 0;
    border-radius: 10px;

    .footer-actions {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.75rem;

      @media (max-width: 768px) {
        flex-direction: column;
      }
    }

    .footer-submit-wrap {
      padding: 0;
      margin: 0;
      width: 100%;
    }

    .remove-btn {
      height: 42px;
      font-size: 14px;
      max-width: 50%;

      @media (max-width: 768px) {
        max-width: 100%;
        width: 100%;
      }
    }

    .progress-bar {
      border-radius: 10px;
    }
  }
</style>
